import { createStart } from '@tanstack/react-start';

// Registering the instance is what makes the `server` route option available. Nothing runs at
// runtime; those routes exist so the build can write their responses to files.
export const startInstance = createStart(() => ({}));
